export default "__VITE_ASSET__66909a1c__"